<div class="find find-orders" (keydown)="altEnterSearch($event)">
  <div class="find-top-content-panels">
    <div #filterViewPane class="bfx-find-filter-view-panel visible" [hidden]="!filterViewShown">
      <p-tabView styleClass="bfx-tabview-primary-md bfx-tabview" #tv>
        <p-tabPanel header="Search" #tvSearch>
          <div class="bfx-find__filter-list" (scroll)="filterView.scrollHandler($event)">
            <bfx-find-orders-filter-view
              #filterView
              (selectSearch)="handleSelectSearch()"
            ></bfx-find-orders-filter-view>
            <div class="bfx-find__filter-list-spacer"></div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Favourites" #tvFav>
          <div class="bfx-find__favorite-list">
            <div *ngIf="favoriteData == null || favoriteData.length==0" class="emptyMessage">
              {{favoriteEmptyMessage}}
            </div>
            <div *ngFor="let data of favoriteData" class="item">
              <div class="text" (click)="selectFavorite(data); tv.open(null,tvSearch);">
                {{data.filterName}}
              </div>
              <bfx-icon-button
                size="sm"
                iconClass="icon_ion_delete_filled"
                (action)="removeFavorite(data)"
                title="Delete"
                [tabindex]="1"
              ></bfx-icon-button>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>

    <div class="bfx-find-blotter-pane" attr.data-result-count="{{resultCount}}">
      <bfx-blotter-orders
        #embeddedBlotter
        [showColumnSelectorStar]="false"
        [showRowColors]="false"
        [tableDefinitionFactory]="tableDefinitionFactory"
        [embeddedContextMenuService]="contextMenuService"
        [embeddedHideUnconfigured]="false"
        [embeddedTableModeSuppressSelection]="false"
      ></bfx-blotter-orders>
    </div>
  </div>
  <div class="bfx-find-action-bar">
    <div class="bfx-find-button-pane bfx-find-button-pane-left">
      <button
        pButton
        #hideButton
        type="button"
        class="bfx-button-secondary-moderate bfx-button-toggle-pane"
        label="{{filterViewShown ? 'Hide' : 'Show'}}"
        icon="{{filterViewShown ? 'fa icon-ion_chevron_double_left' : 'fa icon-ion_chevron_double_right'}}"
        iconPos="{{filterViewShown ? 'left' : 'right'}}"
        [ngClass]="filterViewShown ? 'ui-button-text-icon-left' : 'ui-button-text-icon-right'"
        [tabindex]="2"
        (click)="toggleViewPane()"
      ></button>
      <div *ngIf="filterViewShown" fxLayout="row" fxLayoutGap="4px">
        <button
          class="bfx-button-secondary"
          #clearButton
          type="button"
          [tabindex]="2"
          label="Clear"
          [disabled]="!filterView.hasActiveRow || inProgress"
          (click)="handleClearClick()"
        >
          Clear
        </button>
        <button
          class="bfx-button-primary"
          #searchButton1
          type="button"
          [tabindex]="0"
          label="Search"
          [disabled]="!filterView.hasActiveRow || inProgress"
          (click)="handleSearchClick()"
        >
          Search
        </button>
        <button
          class="bfx-button-secondary"
          #saveButton
          type="button"
          [tabindex]="1"
          label="Save"
          [disabled]="!filterView.hasActiveRow || inProgress"
          (click)="handleSave()"
        >
          Save
        </button>
      </div>
    </div>

    <div class="bfx-find-button-pane bfx-find-button-pane-right">
      <div>{{captionLabel}}</div>
      <button
        *ngIf="canExport"
        class="bfx-button-primary"
        #exportButton
        type="button"
        [disabled]="resultCount == null || resultCount === 0 || embeddedBlotter == null || embeddedBlotter.selectedIdsCount == null || embeddedBlotter.selectedIdsCount == 0"
        [tabindex]="3"
        label="Export"
        (click)="handleExport()"
      >
        Export
      </button>
    </div>
  </div>
</div>

<bfx-find-orders-context-menu
  [currentLadderBlotter]="embeddedBlotter.blotterInstance"
  embeddedTableModeSearchDealtToggle="true"
  bfxElementOnBody
></bfx-find-orders-context-menu>
